import { Tag } from 'antd';
import cn from 'classnames';

import { QUESTIONS_DATA } from './consts';
import styles from './QuestionsList.module.scss';

interface IListItemProp {
  title: string;
  isRequired: boolean;
  type: string;
  description?: string;
  isEditMode: boolean;
}

interface IListProp {
  isEditMode: boolean;
}

const QuestionListItem = ({ title, isRequired, type, description, isEditMode }: IListItemProp) => (
  <li>
    <div className={cn(styles.wrapper, styles.tag, styles[`wrapper-${isEditMode ? 'active' : 'default'}`])}>
      <div className={styles['main-info-wrapper']}>
        <p className={styles.title}>{title}</p>
        {isRequired && (
          <Tag
            className={styles.tag}
            color="volcano"
          >
            Обязательное
          </Tag>
        )}
        <Tag
          className={styles.tag}
          color="default"
        >
          {type}
        </Tag>
      </div>
      {description && <p className={styles.description}>{description}</p>}
    </div>
  </li>
);

export const QuestionsList = ({ isEditMode }: IListProp) => (
  <div>
    <p className={styles['questions-list-description']}>
      Все поля являются обязательными и настроены в соответствии с требованиями
    </p>
    <ul className={styles['questions-list']}>
      {QUESTIONS_DATA.map(({ id, title, isRequired, type, description }) => (
        <QuestionListItem
          key={id}
          title={title}
          isRequired={isRequired}
          type={type}
          description={description}
          isEditMode={isEditMode}
        />
      ))}
    </ul>
    <p className={styles['questions-counter']}>
      Всего полей: <span className={styles['questions-counter-value']}>13</span>
    </p>
  </div>
);
